'use client';

import React, { PropsWithChildren } from 'react';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { createInstance } from 'i18next';
import { Locale } from '@royalaholddelhaize/ah-locale';
import { resources } from './resources/index';

export const I18nProvider: React.FC<PropsWithChildren<{ locale: Locale }>> = ({
    locale,
    children,
}) => {
    const i18nInstance = createInstance();

    i18nInstance.use(initReactI18next).init({
        lng: locale,
        supportedLngs: [Locale.nl_NL, Locale.nl_BE],
        fallbackLng: Locale.nl_NL,
        debug: false,
        resources: {
            [Locale.nl_NL]: {
                'back-button': resources[Locale.nl_NL],
            },
            [Locale.nl_BE]: {
                'back-button': resources[Locale.nl_BE],
            },
        },
        ns: ['back-button'],
    });

    return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
};
